<template>
    <el-dialog
        :visible="visible"
        title="Gửi Duyệt CV: Chuyển Teamlead duyệt"
        width="600px"
        custom-class="rcv-dialog rcv-preliminary-dialog"
        :close-on-click-modal="false"
        append-to-body
        @update:visible="handleClose"
    >
        <div v-if="candidate" class="rcv-preliminary">
            <!-- Thẻ tóm tắt thông tin ứng viên -->
            <div class="rcv-preliminary__candidate-card">
                <div class="rcv-preliminary__candidate-header">
                    <div class="rcv-preliminary__avatar">
                        <i class="el-icon-user-solid"></i>
                    </div>
                    <div class="rcv-preliminary__info">
                        <div class="rcv-preliminary__name">
                            {{ candidate.name || "Chưa có tên ứng viên" }}
                            <span
                                v-if="candidate.source_type"
                                class="rcv-source-pill"
                                :class="Number(candidate.source_type) === 1 ? 'rcv-source-pill--apply' : 'rcv-source-pill--web'"
                            >
                                <i :class="Number(candidate.source_type) === 1 ? 'el-icon-user' : 'el-icon-connection'"></i>
                                {{ Number(candidate.source_type) === 1 ? 'Ứng viên tự apply' : 'Lấy trên mạng' }}
                            </span>
                        </div>
                        <div class="rcv-preliminary__meta">
                            <span v-if="candidateJobTitle" class="rcv-preliminary__meta-item">
                                <i class="el-icon-suitcase"></i> {{ candidateJobTitle }}
                            </span>
                            <span v-if="candidate.phone" class="rcv-preliminary__meta-item">
                                <i class="el-icon-phone-outline"></i> {{ candidate.phone }}
                            </span>
                            <span v-if="candidate.email" class="rcv-preliminary__meta-item">
                                <i class="el-icon-message"></i> {{ candidate.email }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="rcv-preliminary__notice">
                    <i class="el-icon-info"></i>
                    <span>
                        Sau khi gửi duyệt, hồ sơ sẽ chuyển sang trạng thái <b>Team lead cần duyệt</b>. Vui lòng điền đầy đủ thông tin sơ vấn ban đầu để Teamlead nắm được.
                    </span>
                </div>
            </div>

            <!-- Form điền thông tin sơ vấn -->
            <el-form
                ref="formRef"
                :model="form"
                :rules="rules"
                label-position="top"
                size="small"
                @submit.native.prevent="handleSubmit"
            >
                <el-form-item label="Thông tin Sơ vấn" prop="preliminary_info" required>
                    <div class="rcv-form__label-hint">
                        Bắt buộc điền thông tin sơ vấn ứng viên trước khi chuyển Teamlead duyệt
                    </div>
                    <el-input
                        v-model="form.preliminary_info"
                        type="textarea"
                        :rows="6"
                        placeholder="Nhập nội dung thông tin sơ vấn ứng viên (bắt buộc): đánh giá sơ bộ, kỹ năng, mức lương mong muốn, thái độ, thời gian có thể đi làm..."
                        maxlength="2000"
                        show-word-limit
                    />
                </el-form-item>
            </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button size="small" :disabled="submitting" @click="handleClose">Huỷ</el-button>
            <el-button
                type="success"
                size="small"
                icon="el-icon-s-promotion"
                :loading="submitting"
                @click="handleSubmit"
            >
                Xác nhận gửi duyệt
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import { TEAM_LEAD_CAN_DUYET } from "@/core/config/recruitmentCvs/recruitmentCvsOption";

export default {
    name: "PreliminaryReviewDialog",
    props: {
        visible: { type: Boolean, default: false },
        candidate: { type: Object, default: null },
        orders: { type: Array, default: () => [] },
        submitting: { type: Boolean, default: false },
    },
    data() {
        const validatePreliminaryInfo = (rule, value, callback) => {
            if (!value || !value.trim()) {
                callback(new Error("Bắt buộc điền nội dung tại ô Sơ vấn mới gửi được"));
            } else {
                callback();
            }
        };
        return {
            form: {
                preliminary_info: "",
            },
            rules: {
                preliminary_info: [
                    { required: true, message: "Bắt buộc điền nội dung tại ô Sơ vấn mới gửi được", trigger: "blur" },
                    { validator: validatePreliminaryInfo, trigger: ["change", "blur"] },
                ],
            },
        };
    },
    computed: {
        candidateJobTitle() {
            if (!this.candidate) return "";
            const jId = this.candidate.job_id || this.candidate.order_id || this.candidate.raw_job_id;
            if (this.orders && this.orders.length) {
                const found = this.orders.find(
                    (o) => String(o.id) === String(jId)
                );
                if (found) return found.title || found.position_title || `Job #${jId}`;
            }
            return this.candidate.order_title || (jId ? `Job #${jId}` : "");
        },
    },
    watch: {
        visible(val) {
            if (val) {
                this.initForm();
            }
        },
        candidate: {
            immediate: true,
            handler() {
                if (this.visible) {
                    this.initForm();
                }
            },
        },
    },
    methods: {
        initForm() {
            this.form.preliminary_info =
                (this.candidate && (this.candidate.preliminary_info || this.candidate.preliminary_note)) || "";
            this.$nextTick(() => {
                if (this.$refs.formRef) {
                    this.$refs.formRef.clearValidate();
                }
            });
        },
        handleClose() {
            this.$emit("update:visible", false);
        },
        handleSubmit() {
            if (!this.$refs.formRef) return;
            this.$refs.formRef.validate((valid) => {
                if (!valid) return;
                const info = (this.form.preliminary_info || "").trim();
                if (!info) {
                    this.$message.warning("Bắt buộc điền nội dung tại ô Sơ vấn mới gửi được");
                    return;
                }
                this.$emit("submit", {
                    id: this.candidate.id,
                    candidate: this.candidate,
                    hr_approve: 1,
                    status: TEAM_LEAD_CAN_DUYET,
                    preliminary_info: info,
                });
            });
        },
    },
};
</script>

<style scoped>
.rcv-preliminary {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.rcv-preliminary__candidate-card {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 14px 16px;
}
.rcv-preliminary__candidate-header {
    display: flex;
    align-items: center;
    gap: 12px;
}
.rcv-preliminary__avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4f46e5, #6366f1);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
}
.rcv-preliminary__info {
    flex: 1;
    min-width: 0;
}
.rcv-preliminary__name {
    font-size: 15px;
    font-weight: 700;
    color: #0f172a;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}
.rcv-preliminary__meta {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    font-size: 12.5px;
    color: #64748b;
    margin-top: 4px;
}
.rcv-preliminary__meta-item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}
.rcv-preliminary__notice {
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px dashed #cbd5e1;
    font-size: 12px;
    color: #475569;
    display: flex;
    align-items: flex-start;
    gap: 6px;
    line-height: 1.5;
}
.rcv-preliminary__notice i {
    color: #6366f1;
    font-size: 14px;
    margin-top: 2px;
}
.rcv-source-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    font-weight: 600;
    padding: 1px 7px;
    border-radius: 999px;
}
.rcv-source-pill--apply {
    background: #ecfdf5;
    color: #059669;
    border: 1px solid #a7f3d0;
}
.rcv-source-pill--web {
    background: #eff6ff;
    color: #2563eb;
    border: 1px solid #bfdbfe;
}
.rcv-form__label-hint {
    font-size: 12px;
    color: #dc2626;
    margin-bottom: 6px;
    font-weight: 500;
}
</style>
